export default {

    apiUrl: '/api',

    apps: [
        { id: 'mijn-aveco', name: 'Mijn Aveco de Bondt', url: 'https://mijn-aveco.wittigdev.nl' },
        { id: 'monitor', name: 'Monitoringsplatform', url: 'https://aveco-monitor.wittigdev.nl' },
        { id: 'veldwerkwinkel', name: 'Veldwerkwinkel', url: 'https://aveco-veldwerkwinkel.wittigdev.nl' },
        { id: 'loggers', name: 'Loggerdatabase', url: 'https://aveco-loggerdatabase.wittigdev.nl' },
        { id: 'veldwerkdata', name: 'Veldwerkdata', url: 'https://aveco-veldwerkdata.wittigdev.nl' },
    ]
}
